import React from 'react'

export const UsersGeneralTitle = () => {
	return (
		<div className='swatch_user_top_left'>
			<span>Sistema de Usuarios</span>
		</div>
	)
}
